var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 1.25H2.125C1.64175 1.25 1.25001 1.64176 1.25001 2.12499V7.37499C1.25001 7.85825 1.64177 8.25 2.125 8.25H7.375C7.85826 8.25 8.25 7.85824 8.25 7.37499V2.12499C8.25 1.64175 7.85825 1.25 7.375 1.25ZM7.375 2C7.44404 2 7.5 2.05596 7.5 2.12499V7.37499C7.5 7.44403 7.44404 7.5 7.375 7.5H2.125C2.05598 7.5 2.00001 7.44403 2.00001 7.37499V2.12499C2.00001 2.05597 2.05596 2 2.125 2H7.375ZM4.5 9C4.5 8.79289 4.33211 8.625 4.125 8.625C3.9179 8.625 3.75 8.79289 3.75 9V9.875C3.75 10.3582 4.14176 10.75 4.62501 10.75H9.87501C10.3583 10.75 10.75 10.3582 10.75 9.875V4.625C10.75 4.14174 10.3582 3.75 9.87501 3.75H9C8.7929 3.75 8.625 3.91789 8.625 4.125C8.625 4.3321 8.7929 4.5 9 4.5H9.87501C9.94403 4.5 10 4.55596 10 4.625V9.875C10 9.94402 9.94404 9.99999 9.87501 9.99999H4.62501C4.55597 9.99999 4.5 9.94404 4.5 9.875V9Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b850fbc7c68e98d2868819a40f11ccaa.svg";
export { ForwardRef as ReactComponent };